import React, {useContext} from 'react'
import Headshot from './Headshot'
import {appContext} from '../contexts'
import {ABOUT} from '../fn'


const About = () => {
    // const aboutRef = useHeaderChecker(ABOUT_MODE);
    const context = useContext(appContext)
    const ref = context.aboutRef

    return (
        <div className="about" ref={ref} id={ABOUT} >
            <Headshot />
            <h3>DeLesslin “Roo” George-Warren is a queer artist, researcher, and organizer from Catawba Indian Nation whose work ranges from performance to installation art to community education to food sovereignty to language revitalization. Since 2017 he has been the Special Projects Coordinator for the Catawba Cultural Preservation Project where he facilitates the Catawba Language Project, several food sovereignty initiatives, and other community education projects. He has performed, lectured, and exhibited throughout the U.S. including the Utah Museum of Fine Arts, College of Charleston, Vanderbilt University, Ithaca College, and more. In 2018 DeLesslin was recognized as a 2018 “40 Under 40” by the National Council on American Indian Enterprise Development. In 2017 he was selected as a Dreamstarter by Running Strong for American Indian Youth and in 2016 he was recognized as a “25 Under 25” by United National Inter Tribal Youth. </h3>
        </div>
    )
}

export default About
